import { render, staticRenderFns } from "./NoLoginNew.vue?vue&type=template&id=65f199ee&"
import script from "./NoLoginNew.vue?vue&type=script&lang=js&"
export * from "./NoLoginNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports